/**
 * Format raw phone number into (DDD) xxxxx-xxxx
 *
 * @param {string} phoneNumber
 * @returns {string} formattedPhoneNumber
 */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';

  if (phoneNumber.length === 11) {
    return phoneNumber.replace(
      /^(\d{2})(\d{1})(\d{4})(\d{4})$/,
      '($1) $2.$3-$4',
    );
  }

  return phoneNumber.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
};
